import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";
import { mastersBeforeLoad, mastersValidateSearch } from "./_masters";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/masters/clients",
  validateSearch: mastersValidateSearch,
  beforeLoad: mastersBeforeLoad,
  component: lazyRouteComponent(() => import("./masters.clients"), "ClientsPage"),
});
